export default "__VITE_ASSET__4MInG21H__"